import React from 'react';
import type { Node, NodeProps, NodeTypes } from '@xyflow/react';
import { WorkflowNode } from './node';
import type { WorkflowNodeViewData } from './node';
import { WorkflowTrigger } from './trigger';
import type { WorkflowTriggerViewData } from './trigger';
import { WORKFLOW_FLOW_NODE_TYPE } from './workflow-flow-node';
import { WORKFLOW_FLOW_TRIGGER_TYPE } from './workflow-flow-trigger';

/**
 * Cards for a read-only React Flow canvas.
 *
 * The same cards the editor canvas draws, minus the per-node view models that
 * {@link WorkflowFlowNode} and {@link WorkflowFlowTrigger} register. Those are
 * keyed on the entity a card shows, so a surface that can draw one workflow more
 * than once — the nested-workflow tree does exactly that — would register the same
 * id twice. Nothing here is editable, so none of it needs a model.
 *
 * Keyed under the same node types the graph-to-flow pass stamps, so a read-only
 * canvas can hand {@link WORKFLOW_FLOW_PREVIEW_NODE_TYPES} straight to React Flow
 * without relabelling anything.
 */
export const WorkflowFlowPreviewNode: React.FC<
  NodeProps<Node<{ node: WorkflowNodeViewData }>>
> = ({ data }) => <WorkflowNode node={data.node} />;

export const WorkflowFlowPreviewTrigger: React.FC<
  NodeProps<Node<{ trigger: WorkflowTriggerViewData }>>
> = ({ data }) => <WorkflowTrigger trigger={data.trigger} />;

export const WORKFLOW_FLOW_PREVIEW_NODE_TYPES: NodeTypes = {
  [WORKFLOW_FLOW_NODE_TYPE]: WorkflowFlowPreviewNode,
  [WORKFLOW_FLOW_TRIGGER_TYPE]: WorkflowFlowPreviewTrigger,
};
